import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../components/CustomTextArea";
import Flex from "../../../../../../components/Flex";
import { RosTemplate } from "../../../../../../services";

interface MicroProps {
  formik: FormikProps<RosTemplate>;
  disabled?: boolean;
}

const Micro = ({ formik, disabled }: MicroProps) => (
  <Flex gap={2} flexDirection={"column"} mt={2} width={"100%"}>
    <CustomTextArea
      label="Description"
      rows={12}
      disabled={disabled}
      variant="outlined"
      name="description"
      placeholder="Type Something..."
      onBlur={formik.handleBlur}
      value={formik.values?.description}
      onChange={formik.handleChange}
    />
  </Flex>
);

export default Micro;
